import styled from 'styled-components'

export const FunctionContent = styled.div`
  display: flex; /* 縦並び */
  flex-direction: column;
  width: 200px;
  font-size: 16px;
  div:hover {
    ${props => !props.selected ? 'background: #ccc; color: #333;' : ''}
  }
`
export const FunctionContentRow = styled.div`
  display: flex; /* 横並び */
  flex-wrap: wrap;
  text-align: left;
  margin-top: 4px;
  margin-bottom: 4px;
`

const SearchWrap = styled.div`
  display:${props => props.display || 'flex'};
  padding: 1vw;
  width:100vw;
  height:80px;
  flex-wrap: wrap;
  h3 {
    line-height: 32px;
    font-size: 24px;
    margin-right: 16px;
  }
  ul.mainSearch {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    align-items: center;
    position: relative;
    > li {
      display: flex;
      margin: 0 0 16px 1rem;
      label {
        line-height: 32px;
        text-align: right;
        font-size: 12px;
        margin: 0 0.5rem 0 0;
      }
    }
    li.plusButtonLi {
      display: flex;
      margin: 0 0 12px 0;
      label {
        line-height: 32px;
        text-align: right;
        font-size: 16px;
      }
      svg {
        width: 24px;
        height: 32px;
        margin: 0 16px;
        cursor: pointer;

      }
    }
    li.subSearch{
      display: ${props => props.plusButton && props.viewSubSearch ? 'block' : 'none'};
      position: absolute;
      padding: 0 16px;
      margin: 0;
      top: 48px;
      z-index: 3;
      left: -16px;
      background-color: rgba(0,0,0,0.8);
      ul {
        display: flex;
        flex-wrap: wrap;
        > li {
          display: flex;
          margin: 12px 0;
          label {
            display: block;
            line-height: 32px;
            text-align: right;
            font-size: 16px;
          }
        }
      }
    }
  }

  li.mainFunction {
    display: ${props => props.viewFunction? 'block' : 'none' };
    position: absolute;
    align-items: left;
    margin: 0;
    top: 120px;
    z-index: 1;
    left: calc(100vw - 200px - 1rem);
    background-color: #cfe2f3;
    box-shadow: 2px 2px 6px rgba(0,0,0,.4);
  }
  ${props => props.addStyle}
`
export default SearchWrap
